import { render } from "./ErrorCard.vue?vue&type=template&id=60c6adfd&scoped=true"
import script from "./ErrorCard.vue?vue&type=script&lang=js"
export * from "./ErrorCard.vue?vue&type=script&lang=js"

import "./ErrorCard.vue?vue&type=style&index=0&id=60c6adfd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c6adfd"]])

export default __exports__